<div *ngIf="open" class="pdf-modal-overlay" (click)="onOverlayClick()">
  <div class="pdf-modal-content" (click)="$event.stopPropagation()">
    <div class="pdf-modal-header">
      <h2>{{ title }}</h2>
      <div class="pdf-modal-actions">
        <button
          type="button"
          class="pdf-open-external"
          *ngIf="pdfUrl && !loading"
          (click)="openInBrowser()"
          [attr.aria-label]="'dashboard.common.pdfViewer.openExternal' | translate">
          {{ 'dashboard.common.pdfViewer.openExternal' | translate }}
        </button>
        <button
          type="button"
          class="modal-close"
          (click)="close()"
          [attr.aria-label]="'dashboard.common.close' | translate">
          ×
        </button>
      </div>
    </div>
    <div class="pdf-modal-body">
      <div class="pdf-loading" *ngIf="loading">
        <ion-icon name="hourglass-outline" class="loading-icon"></ion-icon>
        <p>{{ 'dashboard.common.pdfViewer.loading' | translate }}</p>
      </div>
      <iframe
        *ngIf="safePdfUrl && !loading"
        class="pdf-viewer"
        [src]="safePdfUrl"
        title="{{ title }}">
      </iframe>
    </div>
  </div>
</div>
